<template>
  <div :class="['form-item-box', { 'change-form-item-box-style': item.changeformItemBoxStyle }]">
    <div v-for="(subitem, subIndex) in item.children" :key="subIndex" class="form-item-content">
      <div class="form-item-label" :style="{ marginBottom: subitem.formItemLabelMarginBottom }">
        <label :for="subitem.field" class="form-item-subTitle">{{ i18n.t(subitem.label) }}</label>
        <span v-if="subitem.subLabel" class="sub-label">{{ i18n.t(subitem.subLabel) }}</span>
      </div>
      <div class="form-item-card">
        <div class="form-item-card-group">
          <input type="text" autocomplete="new-password" style="display: none" />
          <div class="input-wrapper">
            <SafeInput
              v-model="itemValue[`${subitem.field}`]"
              role="input"
              :autocomplete="subitem.inputType === 'text' ? 'off' : 'new-password'"
              :style="{ marginRight: subitem.field === 'cardExpiryDate' ? '16px' : '50px' }"
              :className="[
                'form-item-input',
                { 'form-item-input2': classObject(subIndex) },
                { 'form-item-error-border': subitem.errorShow },
              ]"
              :maxlength="subitem.maxlength"
              :minlength="subitem.minlength"
              :placeholder="getPlaceholder(subitem)"
              :id="subitem.field"
              :type="subitem.inputType"
              @input="handleValueChange($event, subitem.field)"
              @blur="handleValueSend($event, subitem.field)"
              @touchstart="handleInputFocus(subitem.field)"
              @click="handleInputFocus(subitem.field)"
            />
            <img src="~img/img-cvv.png" v-if="subitem.iconShow" alt="cvv" class="img-cvv" />
            <img
              :class="['eye', { 'expire-date': subitem.field === 'cardExpiryDate' }]"
              @click="clickEye(subitem)"
              :src="subitem.on ? eyeOn : eyeOff"
              v-if="subitem.iconShow2"
              alt="cvv"
            />
          </div>
        </div>
        <p v-show="subitem.errorShow" class="form-item-error" :key="subitem.errorMsg">
          {{ subitem.errorMsg }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  // 解决step1弹窗获取不到对应字段的问题
  import i18n from '@/i18n/index';
  import SafeInput from '@/components/SafeInput';

  export default {
    name: 'FormCard',
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      itemFormValue: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      SafeInput,
    },
    mounted() {
      if (this.itemFormValue) {
        const isItem = Object.keys(this.itemFormValue);
        if (isItem?.length) {
          this.itemValue = { ...this.itemValue, ...this.itemFormValue };
        }
      }
    },

    data() {
      return {
        eyeOn: require('@/assets/images/icon-feather-eye-on.svg'),
        eyeOff: require('@/assets/images/icon-feather-eye-off.svg'),
        i18n,
        itemValue: {},
        oldDateNum: '',
        // TODO: 处理input填充问题
        inputReadonly: {
          cardExpiryDate: true,
          cardNum: true,
        },
        on: false,
      };
    },

    methods: {
      getPlaceholder(item) {
        if (!item.placeholder) {
          return '';
        }
        const translated = i18n.t(item.placeholder);
        return translated !== item.placeholder ? translated : item.placeholder;
      },
      classObject(index) {
        if (index) {
          return true;
        }
        return false;
      },
      clickEye(item) {
        item.on = !item.on;
        console.log(item.on);
        if (!item.on) {
          return (item.inputType = 'password');
        }
        return (item.inputType = 'text');
      },
      handleValueChange(e, field) {
        // 卡过期时间格式处理
        let { value } = e.target;

        if (field === 'cardNum') {
          // 判断cardNum当前的值是否为数字
          this.$set(this.itemValue, field, value.replace(/[^\d]/g, ''));
          value = value.replace(/[^\d]/g, '');
        } else if (field === 'cardExpiryDate') {
          // 判断cardExpiryDate当前的值是否为数字 + /
          this.$set(this.itemValue, field, value.replace(/[^\d|/]/g, ''));
          value = value.replace(/[^\d|/]/g, '');
        }

        let { length } = value;

        if (field === 'cardExpiryDate') {
          // 当用户正在删除的情况下
          if (this.oldDateNum > length && length === 2) {
            value = value.slice(0, 1);
            this.$set(this.itemValue, field, value);
            const lg = value.length;
            length = lg;
          }

          // 排除正在删除值的情况
          if (length === 2 && this.oldDateNum - length < 0) {
            this.$set(this.itemValue, field, `${value}/`);
            const lg = value.length;
            length = lg;
          }

          // 最终需要的日期
          if (length === 5) {
            const [n1, n2] = value.split('/');
            this.itemValue[`${'cdeDate'}`] = { expiryMonth: n1, expiryYear: n2 };
          }

          this.oldDateNum = length;
        }

        this.$emit('change', this.itemValue, field);
      },

      // 失去焦点后发送给父组件的数据
      handleValueSend(e, field) {
        this.$emit('value', this.itemValue, field);

        // TODO: 处理input填充问题
        this.inputReadonly[field] = true;
      },

      // TODO: 处理input填充问题
      handleInputFocus(field) {
        this.inputReadonly[field] = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
